export default __webpack_public_path__ + "static/media/alejandro.60a53fc4.jpeg";